import { getAggregateError, } from "@bracket/catch";
import { contract, multiCaller, } from "@bracket/chainography/contracts";
import type { BrktUSD, } from "@bracket/types";
import type { LoadedVault, } from "@types";
import { assetToUsd, deepAssign, } from "@utils";
import { wagmiConfig as config, } from "@wagmiconfig";
import { cache, initialVaultCache, } from ".";


export const strategyTVL = async ({
  vault,
}: {
	vault: LoadedVault;
}): Promise<BrktUSD> => {

	try {

		const { address, denomination, version, } = vault;
		const { decimals, } = denomination;

		const VaultContractName = version === null ? "BracketVault" : "BracketVaultV2";
		const [ [ nav, totalDeposits, totalQueuedDeposits, totalShares, ], errors ] = await multiCaller<[ bigint, bigint, bigint, bigint ]>(config, [
			contract(VaultContractName, "assetsPerShare", address),
			contract(VaultContractName, "totalDeposits", address),
			version ? contract(VaultContractName, "totalQueuedDeposits", address) : contract(VaultContractName, "totalDeposits", address),
			version ? contract(VaultContractName, "totalShares", address) : contract(VaultContractName, "totalActiveShares", address),
		]);

		if(errors) {
			throw getAggregateError(errors, `cache item "strategyTVL" failed for vault ${vault.symbol}`);
		}

		const now = Date.now();
		cache.vaults[address] = cache.vaults[address] || deepAssign({}, initialVaultCache);
		const { time, value, since, } = cache.vaults[address].strategy_tvl;

		if(since > now - time) {
			return value;
		}

		const shares_as_assets = BigInt(Math.floor(Number(totalShares * nav) / (10**decimals)));
		const brkt = totalDeposits + totalQueuedDeposits + shares_as_assets;
		const usd = await assetToUsd(brkt, denomination);

		const next = {
			brkt: brkt.toString(),
			usd,
		};

		cache.vaults[address].strategy_tvl.since = Date.now();
		cache.vaults[address].strategy_tvl.value = next;
		return next;

	}
	catch(err) {
		throw getAggregateError(err, `strategyTVL failed for vault ${vault.symbol} - ${err instanceof Error ? err.message : "without error instance"}`);
	}
}
